import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'), // 使用懒加载
    meta: {
      title: '工商财务 - 智算通'
    }
  },
  {
    path: '/tech',
    name: 'tech',
    component: () => import('../views/TechView.vue'), // 使用懒加载
    meta: {
      title: '软件服务 - 智算通'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'), // 使用懒加载
    meta: {
      title: '关于我们 - 智算通'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), // 更新为Vite环境变量
  routes
})

// 设置页面标题的全局守卫
router.beforeEach((to) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '智算通 - 现代财税+科技服务企业' // 默认标题
  }
})

export default router